import React, { useEffect, useState, useRef } from 'react';
import * as Bixby from '$/core';
import { AppState } from '$/store';
import { connect } from 'react-redux';
import { getIsCurrentUserSuperAdminState } from '$/store/profile/selectors';
import { Formik, Field, ErrorMessage, FormikProps } from 'formik';
import InputBlock from '$/components/global/inputBlock';
import { updateClo } from '$/store/clo/actions';
import DatePickerField from '$/components/datePickerField';
import * as Yup from 'yup';

export interface CloProfileValues {
  id: string;
  name: string;
  manager: string;
  closingDate: Date;
  fitchDealId: string;
  bixbyCloId: string;
  fileName: string;
}
export interface ICloInfoProps {
  isloading?: boolean;
  currentClo?: Bixby.Models.Clo;
  isSuperAdmin: boolean;
  dispatchUpdateClo: (updateRequest: Bixby.Models.CloSlim) => Promise<void>;
}

const CloInfo: React.FC<ICloInfoProps> = props => {
  const { currentClo, dispatchUpdateClo } = props;
  const formikRef = useRef<FormikProps<CloProfileValues>>(null);
  const [initialFormValues, setInitialFormValues] = useState({} as CloProfileValues);

  useEffect(() => {
    if (currentClo && !Bixby.Utils.isNullOrEmpty(currentClo)) {
      setInitialFormValues({
        id: currentClo.id,
        name: currentClo.name || '',
        fitchDealId: currentClo.fitchDealId || '',
        manager: currentClo.manager || '',
        closingDate: currentClo.closingDate,
        bixbyCloId: currentClo.bixbyCloId || '',
        fileName: currentClo.fileName,
      });
    }
  }, [currentClo]);

  const normalRequiredField = Yup.string().max(256, 'Too long').required();

  const schema = Yup.object({
    name: normalRequiredField.required('Clo name is required.'),
  });

  return (
    <div className="admin-profile-section bottom">
      <h3>Profile</h3>
      <Formik
        innerRef={formikRef}
        initialValues={initialFormValues}
        enableReinitialize
        validationSchema={schema}
        onSubmit={async (values: CloProfileValues) => {
          const newClo: Bixby.Models.CloSlim = values;
          await dispatchUpdateClo(newClo);
        }}
        render={({ values, handleSubmit, setFieldValue }) => (
          <form onSubmit={handleSubmit}>
            <div className="profile-input-container">
              <div className="profile-input-column">
                <InputBlock title="CLO Name">
                  <Field type="text" name="name" />
                </InputBlock>
                <ErrorMessage name="name">{msg => <div className="error error-message">{msg}</div>}</ErrorMessage>
                <InputBlock title="CLO Id">
                  <Field type="text" name="fitchDealId" disabled />
                </InputBlock>
                <InputBlock title="Bixby CLO Id">
                  <Field type="text" name="bixbyCloId" disabled />
                </InputBlock>
                <InputBlock title="Manager">
                  <Field type="text" name="manager" />
                </InputBlock>
                <InputBlock title="Closing Date">
                  <DatePickerField
                    name="closingDate"
                    value={values.closingDate}
                    onChange={(_field: string, value: Date) => {
                      if (!value) {
                        setFieldValue('closingDate', undefined);
                      }
                      setFieldValue('closingDate', value);
                    }}
                    dateFormat="MMMM d, yyyy"
                    isRestrictBackdate={true}
                  />
                </InputBlock>
              </div>
            </div>
            <button className="bix_button" type="submit">
              Update
            </button>
          </form>
        )}></Formik>
    </div>
  );
};

const mapStateToProps = (state: AppState) => {
  const { isSuperAdmin } = getIsCurrentUserSuperAdminState(state);
  return {
    isSuperAdmin,
    currentClo: state.cloState.currentClo,
    isLoading: state.cloState.isLoading,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatchUpdateClo: (updateRequest: Bixby.Models.CloSlim) => dispatch(updateClo(updateRequest)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CloInfo);
